// extracted by mini-css-extract-plugin
export var closeButton = "_4f-3";
export var header = "_4f-0";
export var link = "_4f-1";
export var retryButton = "_4f-2";